import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
import classes from './Header.module.css';
import Logo from '../../assets/logo.png';

const HOMEPAGE_PATHS = ['/', '/v1'];

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const closeMenu = () => setMenuOpen(false);
    const { pathname } = useLocation();
    const isHomepage = HOMEPAGE_PATHS.includes(pathname);

    return (
        <div className={classes.header}>
            <div className={classes.navbar}>
                <div className={classes.logo}>
                    <a href="/"> <img src={Logo} alt="logo" /></a>
                </div>
                <button
                    type="button"
                    className={classes.menuToggle}
                    onClick={() => setMenuOpen((open) => !open)}
                    aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                    aria-expanded={menuOpen}
                >
                    <Icon icon={menuOpen ? 'mdi:close' : 'mdi:menu'} width="28" height="28" />
                </button>
                <ul className={`${classes.links} ${menuOpen ? classes.linksOpen : ''}`}>
                    <li><a href="/" onClick={closeMenu}>Home</a></li>
                    <li><a href="/events" onClick={closeMenu}>Events & Results</a></li>
                    {/* <li><a href="/results">Results</a></li> */}
                    <li><a href="/services" onClick={closeMenu}>Services</a></li>
                    <li><a href="/coaching" onClick={closeMenu}>Coaching</a></li>
                </ul>
            </div>

            {isHomepage && (
                <>
                    <p className={classes.header__text}>JOIN THE TRIBE OF RUNNERS</p>
                    <p className={classes.header__subtext}>Join the tribe. Run your race. Achieve your dreams</p>
                </>
            )}
        </div>
    );
}
